const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

// Empty base in local dev → relative paths proxied by Vite to the local identity-service (:4070).
export function getIdentityServiceUrl() {
  return trimTrailingSlash((import.meta.env.VITE_IDENTITY_SERVICE_URL as string | undefined) ?? '')
}

export function getFileServiceUrl() {
  return trimTrailingSlash((import.meta.env.VITE_FILE_SERVICE_URL as string | undefined) ?? 'http://localhost:4060')
}

export function getFileMediaUrl(fileId: string | null | undefined) {
  if (!fileId) return null
  return `${getFileServiceUrl()}/public/files/${encodeURIComponent(fileId)}`
}

// Hosted UI (Cognito) — used only to initiate the Google federation redirect; the broker does the
// token exchange. The SPA can't derive the custom Hosted UI domain from the pool id, so it's config.
export function getHostedUiDomain() {
  const raw = (import.meta.env.VITE_END_USER_HOSTED_UI_DOMAIN as string | undefined) ?? ''
  return raw.replace(/^https?:\/\//, '').replace(/\/+$/, '')
}

export function getEndUserClientId() {
  return (import.meta.env.VITE_END_USER_CLIENT_ID as string | undefined) ?? ''
}
